import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Subject, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LlmService {
  public readonly taskDispatched$ = new Subject<any>();

  constructor(private readonly http: HttpClient) { }

  notifyTaskDispatched(data: any) {
    this.taskDispatched$.next(data);
  }

  dispatchTask(data: any) {
    return this.http.post('inference/tasks/', data);
  }

  getTasks(params: any = {}) {
    return this.http.get('inference/tasks/', { params });
  }

  getTaskById(taskId: any) {
    return this.http.get(`inference/tasks/${taskId}/`);
  }

  retryTask(taskId: any) {
    return this.http.post(`inference/tasks/${taskId}/retry/`, {});
  }

  cancelTask(taskId: any) {
    return this.http.post(`inference/tasks/${taskId}/cancel/`, {});
  }

  getInferenceResult(params: any = {}) {
    return this.http.get('inference/results/', { params }).pipe(
      catchError(() => of(null))
    );
  }

  getEvidence(params: any = {}) {
    return this.http.get('inference/evidence/', { params });
  }

  downloadEvidenceFile(s3Key: string) {
    return this.http.get('inference/evidence/download/', {
      params: { s3_key: s3Key },
      responseType: 'blob'
    });
  }
}
